import React from "react";
import Grid2 from "@mui/material/Grid2";
import {
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  Box,
} from "@mui/material";
import ProcessImage from "../images/customplans/CustomPlans.png";
import Info from "@mui/icons-material/Info";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { PhoneButton, InsideSpans, StyledButton } from "../HomePage/index";
import { Link } from "react-router-dom";

import Slide from "@mui/material/Slide";
import CustomPlansText from "../Text/CustomPlans";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const titleMap = [
  "informationgathering",
  "designing",
  "adjustments",
  "finalization",
  "permitting",
  "construction",
];

class CustomPlans extends React.Component {
  constructor(props) {
    super(props);
    this.state = { informationDialogOpen: false, informationDialogHTML: null };
  }

  closeDialog = () => {
    this.setState({ informationDialogOpen: false });
  };

  loadContent = (title) => () => {
    this.setState({
      informationDialogHTML: (
        <span>
          {CustomPlansText[title].header} {CustomPlansText[title].body}
        </span>
      ),
      informationDialogOpen: true,
    });
  };

  render() {
    return (
      <Grid2
        xs={12}
        container
        sx={{
          width: "100%",
          maxWidth: "100%",
          paddingBottom: { xs: "5px" },
          paddingTop: 0,
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 0,
            overflowX: "hidden",
          }}
        >
          <Box
            sx={{
              textAlign: "left",
              position: { xs: "relative", sm: "block" },
              flex: { xs: "1 1 100%", sm: "0 0 40%", md: "0 0 25%" },
              overflow: "hidden",
              minWidth: 0,
            }}
          >
            <img 
              src={ProcessImage} 
              alt="Process of drawing custom plans" 
              style={{ 
                maxWidth: "100%", 
                maxHeight: "1200px",
                height: "auto", 
                width: "100%",
                display: "block",
                objectFit: "contain"
              }}
            />
            <Typography
              component="span"
              sx={{ zIndex: 9000}}
              display={{ xs: "block", sm: "none" }}
            >
              {Object.keys(CustomPlansText).map((title, index) => (
                <PhoneButton
                  key={`PhoneButton${index}`}
                  onClick={this.loadContent(CustomPlansText[title].link)}
                  top={`calc(100% / 7 * ${index + 1})`}
                  spanlabels={CustomPlansText[title].title}
                  icon={<Info />}
                />
              ))}
            </Typography>
          </Box>
          <Box
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 auto" },
              paddingLeft: { sm: "8px" },
              minWidth: 0,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "#9aa2ae",
                fontFamily: "Economica",
                lineHeight: { xs: "19.7px", md: "22px" },
              }}
            >
              {Object.keys(CustomPlansText).map((title, index) => (
                <span key={`customText${index}`}>
                  {CustomPlansText[title].header}
                  {CustomPlansText[title].body}
                </span>
              ))}
            </Typography>
          </Box>
        </Box>
        <Grid2
          xs={12}
          sx={{
            textAlign: "center",
            paddingTop: { xs: "20px", sm: "40px" },
            width: "100%",
          }}
        >
          <StyledButton component={Link} to="/requestquote" variant="contained">
            <InsideSpans>
              Request
              <br /> Quote
            </InsideSpans>
          </StyledButton>
        </Grid2>
        <Dialog
          TransitionComponent={Transition}
          fullScreen
          open={this.state.informationDialogOpen}
          onClose={this.closeDialog}
          sx={{ marginRight: "30px" }}
        >
          <DialogContent sx={{ paddingTop: "30px" }}>
            <IconButton onClick={this.closeDialog}>
              <ArrowBack />
            </IconButton>
            <br />
            <Typography
              variant="caption"
              sx={{
                color: "#9aa2ae",
                fontFamily: "Economica",
                lineHeight: { xs: "19.7px", md: "22px" },
              }}
            >
              {this.state.informationDialogHTML}
            </Typography>
            <StyledButton onClick={this.closeDialog} variant="contained">
              <InsideSpans>Back</InsideSpans>
            </StyledButton>
          </DialogContent>
        </Dialog>
      </Grid2>
    );
  }
}

export default CustomPlans;
